module.exports = __webpack_public_path__ + "img/item_1.9065be31.png";